<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>오시는 길</h3>
                            <div class="h6 mt-4">
                                시즌마다 선착장이 다릅니다. 오시기 전에 전화 후 확인해주세요.
                            </div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row text-left">
                                <div class="col-lg-2">
                                    <div class="h4 font-weight-300">
                                        안흥유람선
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <p>
                                        <span class="btn-ad">주소</span>
                                        &nbsp;충청남도 태안군 근흥면 신진부두길 109 안흥유람선
                                    </p>
                                    <p>
                                        <span class="btn-ad">전화</span>
                                        &nbsp;010-6420-3139
                                    </p>
                                </div>
                                <div class="col">
                                    
                                    <p>
                                        <span class="btn-ad">오시는 법</span>
                                        
                                        &nbsp;<a href="https://map.naver.com/p/search/안흥유람선/place/12767276?c=15.00,0,0,0,dh&isCorrectAnswer=true" target="_blank"><span class="btn-naver bg-line-4">네이버 지도</span></a>
                                        &nbsp;<a href="https://m.map.kakao.com/actions/detailMapView?id=1927896213&refService=place" target="_blank"><span class="btn-naver bg-line-9">카카오 맵</span></a>

                                    </p>
                                    <!-- <p>
                                        &nbsp;지하철 4호선 동작역 (9번 출구) 도보 10분 소요
                                        <br>&nbsp;지하철 9호선 흑석역 (2번 출구) 도보 10분 소요
                                    </p> -->
                                </div>
                                <div class="col-lg-12">
                                    <div id="map1" style="width:100%;height:400px;"></div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="mt-5 py-5 border-top text-center">
                            <div class="row text-left">
                                <div class="col-lg-2">
                                    <div class="h4 font-weight-300">
                                        황골선착장
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <p>
                                        <span class="btn-ad">주소</span>
                                        &nbsp;충남 태안군 근흥면 도황리 황골선착장
                                    </p>
                                    <p>
                                        <span class="btn-ad">전화</span>
                                        &nbsp;010-6420-3139
                                    </p>
                                </div>
                                <div class="col">
                                    
                                    <p>
                                        <span class="btn-ad">오시는 법</span>
                                        &nbsp;<a href="https://map.naver.com/p/search/%ED%99%A9%EA%B3%A8%EC%84%A0%EC%B0%A9%EC%9E%A5/place/17678248?c=15.58,0,0,0,dh&isCorrectAnswer=true" target="_blank"><span class="btn-naver bg-line-4">네이버 지도</span></a>
                                        &nbsp;<a href="https://m.map.kakao.com/actions/detailMapView?id=24941476&refService=place" target="_blank"><span class="btn-naver bg-line-9">카카오 맵</span></a>

                                    </p>                                    
                                </div>
                                <div class="col-lg-12">
                                    <div id="map2" style="width:100%;height:400px;"></div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name : 'location',
    data() {
        return {
        }
    },
    mounted() {
        this.loadNaverMap();
    },
    methods:{
        loadNaverMap(){
            // 네이버 지도 API 로드
            const script = document.createElement("script");
            script.src = "https://oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=v78y1ozif6";
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.initMap();
            };

            document.head.appendChild(script);
        },
        initMap(){
            // 네이버 지도 생성
            let map1 = new window.naver.maps.Map("map1", {
                center: new window.naver.maps.LatLng(36.681250, 126.134797),
                zoom: 15,
                minZoom: 10,
                zoomControl: true,
                zoomControlOptions: { //줌 컨트롤의 옵션
                    position: naver.maps.Position.TOP_RIGHT
                }
            });

            // 마커 생성
            let marker1 = new naver.maps.Marker({
                position: new naver.maps.LatLng(36.681250, 126.134797),
                map: map1
            });

            
            // 네이버 지도 생성
            let map2 = new window.naver.maps.Map("map2", {
                center: new window.naver.maps.LatLng(36.68287, 126.2007),
                zoom: 15,
                minZoom: 10,
                zoomControl: true,
                zoomControlOptions: { //줌 컨트롤의 옵션
                    position: naver.maps.Position.TOP_RIGHT
                }
            });

            // 마커 생성
            let marker2 = new naver.maps.Marker({
                position: new naver.maps.LatLng(36.68287, 126.2007),
                map: map2
            });
        }
    }
}

</script>
<style>
    .btn-ad{
        color: #9e1c4e;
        border: 1px solid #9e1c4e;
        padding: 3px 10px;
        font-size: 15px;
        display: inline-block;
        text-align: center;
        position: relative;
    }

    .btn-naver{
        color: #FFF;
        border: 1px solid darkgray;
        border-radius: 1em;
        padding: 3px 10px;
        font-size: 15px;
        display: inline-block;
        text-align: center;
        position: relative;
    }

    .bg-line-4 {
        background-color: #2DB400;
    }

    .bg-line-9 {
        background-color: #FFD700;
        color:blue
    }
</style>